import React from 'react';
import './App.css';
import Main from "./Views/Main/Main";
import Trends from "./Views/Trends/Trends";
import KnowHow from "./Views/KnowHow/KnowHow";
import Transformation from "./Views/Transformation/Transformation";
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Kontakt from './Views/Kontakt/Kontakt';
import Warenkorb from './Views/Warenkorb/Warenkorb';
import MegatrendDetail from './Views/Trends/MegatrendDetail';
import { CartProvider } from './Views/Context/CardContext';
import Datenschutzhinweise from './Views/Datenschutzhinweise/Datenschutzerklaerung';

function App() {
    return (
        <CartProvider>
            <Router>
                <Routes>
                    <Route path="/" element={<Main />} />
                    <Route path="/Trends" element={<Trends />} />
                    <Route path="/Know-How" element={<KnowHow />} />
                    <Route path="/Transformation" element={<Transformation />} />
                    <Route path="/Konakt" element={<Kontakt />} />
                    <Route path="/Warenkorb" element={<Warenkorb />} />
                    <Route path="/megatrend/:id" element={<MegatrendDetail />} />
                    <Route path="/Datenschutzerklaerung" element={<Datenschutzhinweise />} />
                </Routes>
            </Router>
        </CartProvider>
    );
}

export default App;